<h2 mat-dialog-title class="text-lg">Edit Event</h2>
<mat-dialog-content>
  <span *ngIf="!event">
    Loading...
  </span>

  <form (ngSubmit)="submit()" *ngIf="event">
    <!--    // todo:remove selected index-->
    <mat-tab-group mat-align-tabs="start">
      <mat-tab label="Basic" [formGroup]="viewModel.form">
        <div class="space-y-md mb-sm mt-md">
          <div class="form-group">
            <app-textfield
              label="Stream Title"
              formControlName="title"
            ></app-textfield>
          </div>
          <div class="form-group">
            <app-dropdown
              label="Visibility"
              formControlName="visibility"
              [options]="[
                { value: 'private', label: 'Private' },
                { value: 'public', label: 'Public' },
                { label: 'Unlisted', value: 'unlisted' }
              ]"
            ></app-dropdown>
          </div>
          <div class="form-group">
            <app-dropdown
              formControlName="link"
              [options]="linkDropdownOptions"
              label="Stream URL"
            >
            </app-dropdown>
          </div>

          <div>
            <label>Casing</label>
            <mat-slide-toggle formControlName="uppercase">
              {{ (viewModel.form.value.uppercase) ? 'UPPERCASE' : 'Lowercase' }}
            </mat-slide-toggle>
          </div>


        </div>


      </mat-tab>
      <mat-tab label="Outputs">
        <div class="space-y-md mb-sm mt-md">
          <!--          <h2>Encoders</h2>-->
          <h2>Zoom Links</h2>
          <p-table [value]="zoomLinks | async" editMode="row" dataKey="id" #dt [editingRowKeys]="rowsEditing">
            <ng-template pTemplate="caption" let-rowData>
              <div style="text-align:left">
                <button type="button" pButton icon="fa fa-plus" (click)="add(dt)" label="Add"></button>
              </div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th>Link</th>
                <th>Output Language</th>
                <th>Status</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-zoomLink let-editing="editing" let-ri="rowIndex">
              <tr [pEditableRow]="zoomLink">
                <td pEditableColumn style="text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <input *ngIf="zoomLink" pInputText name="link" type="text" [(ngModel)]="zoomLink.zoomApiLink">
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{zoomLink.zoomApiLink}}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td pEditableColumn>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <p-dropdown [options]="languages" name="outputLanguage" appendTo="body"
                                  [(ngModel)]="zoomLink.outputLanguage" [style]="{'width':'100%'}"></p-dropdown>

                    </ng-template>
                    <ng-template pTemplate="output">
                      {{zoomLink.outputLanguage}}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td pEditableColumn>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <p-dropdown [options]="zoomLinkStatuses" name="enabled" appendTo="body"
                                  [(ngModel)]="zoomLink.enabled" [style]="{'width':'100%'}"></p-dropdown>

                    </ng-template>
                    <ng-template pTemplate="output">
                      {{zoomLink.enabled ? 'Enabled' : 'Disabled'}}
                    </ng-template>
                  </p-cellEditor>
                </td>

                <td style="text-align:center">
                  <button *ngIf="!editing" pButton type="button" pInitEditableRow icon="pi pi-pencil"
                          (click)="onRowEditInit(zoomLink)" class="p-button-rounded p-button-text"></button>
                  <button *ngIf="!editing" pButton icon="pi pi-trash" class="p-button-text p-button-rounded"
                          (click)="$event.preventDefault(); deleteEncoder(zoomLink)"></button>
                  <button *ngIf="editing" pButton type="button" pSaveEditableRow icon="pi pi-check"
                          (click)="onRowEditSave(zoomLink)"
                          class="p-button-rounded p-button-text p-button-success mr-2"></button>
                  <button *ngIf="editing" pButton type="button" pCancelEditableRow icon="pi pi-times"
                          (click)="onRowEditCancel(zoomLink, ri)"
                          class="p-button-rounded p-button-text p-button-danger"></button>

                </td>
              </tr>
            </ng-template>

          </p-table>
        </div>
      </mat-tab>
      <mat-tab label="Advanced" [formGroup]="viewModel.form">
        <div class="space-y-md mb-sm mt-md">


          <div>
            <app-dropdown [options]="purgeOptions" formControlName="purgeFrequency"
                          label="Purge Frequency"></app-dropdown>

          </div>


          <div class="form-group">
            <a
              class="btn btn-link pl-0 mr-auto"
              style="padding-left: 0 !important"
              (click)="modalService.close()"
              routerLink="/events/{{ event.shortId }}/transcoders"
              target="_blank"
            >
              Manage Transcoders
            </a>
          </div>

          <div>
            <button (click)="deleteEvent()" class="btn btn-tertiary">
              Delete Event
            </button>
          </div>


        </div>
      </mat-tab>
    </mat-tab-group>
  </form>

</mat-dialog-content>
<mat-dialog-actions>

  <div class="flex justify-end ml-auto">

    <button class="btn btn-secondary mr-sm" [mat-dialog-close]="true">Close</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button class="btn btn-primary" (click)="submit()">
      Save
    </button>
  </div>
</mat-dialog-actions>


